<template>
  <div>
    <b-modal id="modal-pilih-jadwal" centered scrollable :title="`JADWAL ${tanggal}`" header-bg-variant="secondary" header-text-variant="dark" @show="showModal()" @hidden="reset()" hide-footer>
      <!-- {{data}} -->
      <b-row>
        <b-col md="12" lg="12" xl="12">
          <b-row align="center" v-if="data" class="text-center mb-4">
            <b-col>
              <b-img rounded="circle" thumbnail fluid class="profile-avatar mb-3" src="https://picsum.photos/seed/picsum/200/200" />
              <h2 class="profile-name">{{ data.namaKaryawan }}</h2>
              <p class="profile-role mb-0">{{ data.namaPosisi }}</p>
            </b-col>
          </b-row>
          <!-- dataShift : {{dataShift}} -->
          <!-- <b-card>
            <div class="d-flex justify-content-between">
              <div class="d-flex">
                <h3 class="m-0 p-0 my-auto mr-4" style="font-weight: 400">{{tanggal}}</h3>
                <div class="">
                  <p class="m-0 p-0">{{data.namaPosisi}}</p>
                  <h4 class="m-0 p-0">{{data.namaKaryawan}}</h4>
                </div>
              </div>
              <p class="m-0 p-0 text-success" style="">{{data.jumlahJam}} Jam</p>
            </div>
          </b-card> -->
          <b-card v-if="dataShift" @click="openEdit = tanggalLewat ? false : !openEdit">
            <!-- <b-card class="p-0 m-0 mb-2" style="height: 20px;" :style="`background-color: ${dataShift.warna};`"></b-card> -->
            <b-button type="button" class="btn w-100 mb-2" :style="`background-color: ${dataShift.warna};`"></b-button>
            <div class="text-center">
              <h3>
                <span v-if="dataShift.masterShiftId">
                  <span> {{ dataShift.namaCabang }}</span>
                  <span> - </span>
                </span>
                <span> {{ dataShift.namaShift }}</span>
              </h3>
              <h4 v-if="dataShift.masterShiftId" :style="`color: ${dataShift.warna}`">
                <span> {{ dataShift.kategoriShift }}</span>
                <span> {{ dataShift.namaJamKerja }}</span>
              </h4>
            </div>
            <!-- <div class="mb-1 d-flex justify-content-between">
              <div class="d-flex">
                <div class="">
                  <h6 class="m-0 p-0 mb-1">{{ dataShift.namaCabang }}</h6>
                  <h4 class="m-0 p-0">
                    {{ dataShift.kategoriShift }} -
                    <span class="text-success">{{ dataShift.namaShift }}</span>
                  </h4>
                </div>
              </div>
              <div class="py-auto" style="white-space: nowrap">
                <h5 class="m-0 p-0 mb-1" style="">
                  {{ dataShift.namaJamKerja }}
                </h5>
                <p class="m-0 p-0 text-right">
                  {{ dataShift.namaNominalUpah }}
                </p>
              </div>
            </div> -->
            <!-- <div class="w-100 btn-group mt-3" role="group" aria-label="Basic example">
              <b-button
                type="button"
                class="btn px-3"
                variant="warning"
                :disabled="tanggalLewat"
                @click="openEdit = true"
              ><CIcon name="cil-pencil" /></b-button>
              <b-button
                type="button"
                class="btn px-3"
                variant="danger"
                :disabled="tanggalLewat"
                @click="$bvModal.show('modal-hapus-jadwal')"
              ><CIcon name="cil-trash" /></b-button>
            </div> -->
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="!tanggalLewat && (!dataShift || openEdit)">
        <b-col cols="12" class="mb-3">
          <multiselect
            v-model="filter.cabang"
            :options="listCabang"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            label="namaCabang"
            track-by="cabangId"
            placeholder="-- Pilih Cabang --"
          ></multiselect>
        </b-col>

        <b-col cols="12">
          <b-row>
            <b-col cols="6" v-for="(data, key) in listShift" :key="key" class="mb-3">
              <b-card
                v-if="data.type !== 'delete'"
                v-b-modal.confirm-shift-modal
                class="shift-option text-center"
                :style="`background-color: ${data.warna};`"
                :class="{ disabled: tanggalLewat || data.disabled }"
                @click="!tanggalLewat && !data.disabled ? (pilihDataShift = data) : null"
              >
                <h5 class="shift-title">{{ data.namaShift }}</h5>
                <p v-if="data.masterShiftId" class="shift-time mb-0">
                  {{ data.namaJamKerja }}
                </p>
              </b-card>

              <!-- Delete card -->
              <b-card v-else class="shift-option text-center" :style="`background-color: ${data.warna};`" @click="!tanggalLewat ? $bvModal.show('confirm-delete-modal') : null">
                <h5 class="shift-title">Delete</h5>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-modal
        id="confirm-delete-modal"
        centered
        hide-footer
        size="sm"
        modal-class="confirm-modal"
        @shown="$refs.confirmDeleteContent.classList.add('shake')"
        @hidden="$refs.confirmDeleteContent.classList.remove('shake')"
      >
        <div ref="confirmDeleteContent" class="text-center">
          <div class="confirm-icon mb-3">
            <b-icon icon="exclamation-triangle-fill" variant="danger" font-scale="2"></b-icon>
          </div>
          <h4 class="confirm-title">Konfirmasi Hapus</h4>
          <p class="confirm-text">Apakah anda yakin ingin menghapus shift ini?</p>
          <div class="d-flex justify-content-center mt-4">
            <b-button variant="danger" class="confirm-btn mr-2" @click="hapusShift()"> <i class="fas fa-trash mr-1"></i> Hapus </b-button>
            <b-button variant="secondary" class="confirm-btn" @click="$bvModal.hide('confirm-delete-modal')"> Batal </b-button>
          </div>
        </div>
      </b-modal>

      <b-modal id="confirm-shift-modal" centered hide-footer title="" size="sm" modal-class="confirm-modal">
        <div class="text-center">
          <!-- Icon -->
          <div class="confirm-icon mb-3">
            <b-icon icon="question-circle-fill" variant="warning" font-scale="2"></b-icon>
          </div>

          <!-- Title -->
          <h4 class="confirm-title">Konfirmasi</h4>
          <p class="confirm-text">Apakah anda yakin memilih shift ini?</p>

          <!-- Buttons -->
          <div class="d-flex justify-content-center mt-4">
            <b-button variant="success" class="confirm-btn mr-2" @click="pilihShift()"> <i class="fas fa-check mr-1"></i> Ya </b-button>
            <b-button variant="danger" class="confirm-btn" @click="$bvModal.hide('confirm-shift-modal')"> <i class="fas fa-times mr-1"></i> Batal </b-button>
          </div>
        </div>
      </b-modal>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/id";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "modalInputMasterJadwal",
  components: { Multiselect },
  props: ["data", "dataShift", "tanggal", "listCabang"],
  data() {
    return {
      moment,
      pilihDataShift: {},
      openEdit: false,
      button: "Simpan",
      busy: false,
      listShift: [],
      filter: {
        cabang: null,
      },
      tableBusy: false,
    };
  },
  computed: {
    tanggalLewat() {
      return this.tanggal ? this.moment(this.tanggal, "DD-MM-YYYY").isBefore(this.moment(this.moment().format("DD-MM-YYYY"), "DD-MM-YYYY")) : false;
    },
  },
  watch: {
    openEdit: function (newVal, oldVal) {
      if (newVal != oldVal && newVal) {
        this.getDataShift();
      }
    },
    "filter.cabang": function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDataShift();
      }
    },
    "data.cabang": function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.filter.cabang = this.data.cabang;
      }
    },
  },
  async mounted() {
    this.getDataShift();
  },
  methods: {
    showModal() {
      const vm = this;
      vm.openEdit = false;
      // console.log(vm.filter)
      // console.log('data', vm.data)
      // console.log('dataShift', vm.dataShift)
      // console.log('tanggal', vm.tanggal)
    },
    async getDataShift() {
      const vm = this;
      vm.tableBusy = true;
      const listShift = await vm.$axios.post("/masterShift/list", {
        cabangId: vm.filter.cabang ? vm.filter.cabang.cabangId : null,
      });
      if (listShift.data.status == 200) {
        vm.listShift = [];

        // inject Day Off
        listShift.data.data.push({
          masterShiftId: null,
          namaCabang: "",
          namaShift: "Day Off",
          namaJamKerja: "",
          namaNominalUpah: "",
          warna: "#CED2D8",
          type: "dayoff",
        });

        // inject Delete option
        listShift.data.data.push({
          masterShiftId: "DELETE",
          namaCabang: "",
          namaShift: "Delete",
          namaJamKerja: "",
          namaNominalUpah: "",
          warna: "#dc3545",
          type: "delete",
        });

        for (let i = 0; i < listShift.data.data.length; i++) {
          const x = listShift.data.data[i];
          if (vm.dataShift && x.masterShiftId == vm.dataShift.masterShiftId) {
            x.disabled = true;
          }
          vm.listShift.push({
            ...x,
            namaJamKerja: x.jamMasuk && x.jamKeluar ? moment(x.jamMasuk, "HH:mm:ss").format("HH:mm") + " - " + moment(x.jamKeluar, "HH:mm:ss").format("HH:mm") : "",
            namaNominalUpah: x.nominalUpah ? vm.toNumeric(x.nominalUpah, "idr") : "",
          });
        }
      }
      vm.totalRows = vm.listShift.length;
      vm.tableBusy = false;
    },
    async pilihShift() {
      const vm = this;
      if (!vm.openEdit) {
        //register
        const register = await vm.$axios.post("/masterShift/createJadwal", {
          dataKaryawanId: vm.data.dataKaryawanId,
          bulkJadwal: [
            {
              masterShiftId: vm.pilihDataShift.masterShiftId || null,
              cabangId: vm.pilihDataShift.cabangId || null,
              tanggalAbsen: vm.$moment(vm.tanggal, "DD-MM-YYYY").format("YYYY-MM-DD"),
              hariAbsen: vm.$moment(vm.tanggal, "DD-MM-YYYY").format("dddd"),
            },
          ],
        });
        console.log("register", register);
        vm.$bvModal.hide("modal-pilih-data");
        if (register.data.status == 200) {
          vm.$bvModal.hide("modal-pilih-jadwal");
          vm.$emit("triggerAlert", {
            variant: "success",
            msg: "BERHASIL MENGUBAH JADWAL",
            show: true,
          });
        } else {
          vm.$emit("triggerAlert", {
            variant: "danger",
            msg: register.data.message.toUpperCase(),
            show: true,
          });
        }
      } else {
        //update
        const update = await vm.$axios.post("/absensiKaryawanMobile/update", {
          id: vm.dataShift.absensiKaryawanMobileId,
          dataKaryawanId: vm.data.dataKaryawanId,
          cabangId: vm.pilihDataShift.cabangId,
          masterShiftId: vm.pilihDataShift.masterShiftId,
          tanggalAbsen: vm.moment(vm.tanggal, "DD-MM-YYYY").format("YYYY-MM-DD"),
          hariAbsen: vm.$moment(vm.tanggal, "DD-MM-YYYY").format("dddd"),
        });
        console.log("update", update);
        vm.$bvModal.hide("modal-pilih-data");
        if (update.data.status == 200) {
          vm.openEdit = false;
          vm.$bvModal.hide("modal-pilih-jadwal");
          vm.$emit("triggerAlert", {
            variant: "success",
            msg: "BERHASIL MENGUBAH JADWAL",
            show: true,
          });
        } else {
          vm.$emit("triggerAlert", {
            variant: "danger",
            msg: update.data.message.toUpperCase(),
            show: true,
          });
        }
      }
    },
    async hapusShift() {
      const vm = this;
      const hapus = await vm.$axios.post("/absensiKaryawanMobile/delete", {
        id: vm.dataShift.absensiKaryawanMobileId,
      });
      console.log("hapus", hapus);
      vm.$bvModal.hide("modal-hapus-jadwal");
      if (hapus.data.status == 200) {
        vm.$bvModal.hide("modal-pilih-jadwal");
        vm.$emit("triggerAlert", {
          variant: "success",
          msg: "BERHASIL MENGHAPUS JADWAL",
          show: true,
        });
      } else {
        vm.$emit("triggerAlert", {
          variant: "danger",
          msg: "GAGAL MENGHAPUS JADWAL",
          show: true,
        });
      }
    },
    reset() {
      const vm = this;
      vm.$emit("changeVar", { name: "data", data: {} });
      vm.$emit("changeVar", { name: "dataShift", data: {} });
      vm.$emit("changeVar", { name: "tanggal", data: null });
      vm.openEdit = false;
    },
    toNumeric(number, type) {
      let data = {};
      if (type == "no-idr") {
        return new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
        })
          .format(number)
          .slice(3);
      } else {
        if (type == "idr") data = { style: "currency", currency: "IDR" };
        return new Intl.NumberFormat("id-ID", data).format(number);
      }
    },
  },
};
</script>

<style scoped>
/* Profile section */
.profile-avatar {
  width: 140px;
  height: 140px;
  object-fit: cover;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.profile-name {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
}

.profile-role {
  font-size: 16px;
  font-weight: 500;
  color: #7c7c7c;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Shift option */
.shift-option {
  border-radius: 12px;
  padding: 16px;
  min-height: 90px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  color: #fff;
}

.shift-option:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.shift-option.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.shift-title {
  font-size: 16px;
  font-weight: 600;
}

.shift-time {
  font-size: 14px;
  font-weight: 400;
}

.confirm-modal .modal-content {
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.confirm-icon {
  font-size: 48px;
  color: #ffc107; /* gold warning color */
}

.confirm-title {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
}

.confirm-text {
  font-size: 15px;
  color: #555;
  margin-top: 6px;
}

.confirm-btn {
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  min-width: 90px;
}

/* delete modal */

@keyframes shake {
  0% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-6px);
  }
  40% {
    transform: translateX(6px);
  }
  60% {
    transform: translateX(-4px);
  }
  80% {
    transform: translateX(4px);
  }
  100% {
    transform: translateX(0);
  }
}

.confirm-modal .modal-content {
  animation: shake 0.4s ease-in-out;
}
.shake {
  animation: shake 0.4s ease-in-out;
}
</style>
